import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=75bfa151&scoped=true&"
import script from "./Carousel.vue?vue&type=script&lang=ts&"
export * from "./Carousel.vue?vue&type=script&lang=ts&"
import style0 from "./Carousel.vue?vue&type=style&index=0&id=75bfa151&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bfa151",
  null
  
)

export default component.exports